// List of Locales that Coursera supports
// The format is <lang>-<countryCode>
// For the human readable name refer to: https://en.wikipedia.org/wiki/List_of_language_names

export default {
  'en-US': 'English',
  // Arabic
  'ar-SA': 'العَرَبِيَّة‎',
  // Azerbaijani
  'az-AZ': 'Azərbaycan dili',
  // German
  'de-DE': 'Deutsch',
  // Greek
  'el-GR': 'Ελληνικά',
  // Spanish
  'es-LA': 'Español',
  // Dari
  'fa-AF': 'دری',
  // French
  'fr-FR': 'Français',
  // Hindi
  'hi-IN': 'हिन्दी',
  // Hungarian
  'hu-HU': 'Magyar',
  // Indonesian
  'id-ID': 'Bahasa Indonesia',
  // Italian
  'it-IT': 'Italiano',
  // Japanese
  'ja-JP': '日本語',
  // Korean
  'ko-KR': '한국어',
  // Kazakh
  'kk-KZ': 'Қазақша',
  // Dutch
  'nl-NL': 'Nederlands',
  // Polish
  'pl-PL': 'polski',
  // Pashto
  'ps-AF': 'پښتو',
  // Portuguese
  'pt-BR': 'Português (Brasil)',
  // Russian
  'ru-RU': 'Русский',
  // Swedish
  'sv-SE': 'Svenska',
  // Turkish
  'tr-TR': 'Türkçe',
  // Thai
  'th-TH': 'ภาษาไทย',
  // Ukrainian
  'uk-UA': 'Українська',
  // Uzbek
  'uz-UZ': 'Oʻzbek',
  //Vietnamese
  'vi-VN': 'Tiếng Việt',
  // Chinese (Simplified)
  'zh-CN': '中文(简体)',
  // Chinese (Traditional)
  'zh-TW': '中文(繁體)',
} as const;
